export default __webpack_public_path__ + "static/media/imone-title-en.66fcf6d3.webp";